// Represent YouTube videos instead of static images
const youtubeThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

// Updated with actual YouTube video titles
const Project = [
    { Id: '1', cTitle: 'Lesson: At the Airport', pImg: youtubeThumb('cXMJd0dO7ro'), videoId: 'cXMJd0dO7ro' },
    { Id: '2', cTitle: 'School Trip Lesson', pImg: youtubeThumb('tJiJwgNvEEY'), videoId: 'tJiJwgNvEEY' },
    { Id: '3', cTitle: 'Fire Safety Lesson', pImg: youtubeThumb('GAEfJhevq9A'), videoId: 'GAEfJhevq9A' },
    { Id: '4', cTitle: 'Lesson: Dhuha is Sick', pImg: youtubeThumb('9bKS_bAyuhM'), videoId: '9bKS_bAyuhM' },
    { Id: '5', cTitle: 'Lesson: Tariq Visits His Uncle', pImg: youtubeThumb('vfi0xLzNb-4'), videoId: 'vfi0xLzNb-4' },
    { Id: '6', cTitle: 'Arabic Learning Adventure with Us!', pImg: youtubeThumb('0ISdB5CSMZM'), videoId: '0ISdB5CSMZM' },
]

export default Project;